<template>
  <div class="containter">
    <navTop class="navTop navFixed" :topFixed="true" :topIndex="topIndex" :childrenIndex="childrenIndex" />
    <banner :bannerObj="bannerObj" @dialogVisible="getChild" />
    <p class="problem-title">行业痛点</p>
    <ul class="problem">
      <li v-for="(item, index) in problemArr" :key="index">
        <div class="proble-box">
          <p class="proble-title">{{item.label}}</p>
          <p class="proble-line"></p>
        </div>
        <p class="proble-content">{{item.content}}</p>
      </li>
    </ul>
    <product-content
      :productContentArr = product
      :productTitle = title
    />
    <footer-a />
    <back-top />
    <dialog-business :dialogVisible="dialogVisible" @dialogVisible="closeFn"/>
  </div>
</template>

<script>
import navTop from '../components/nav'
import banner from '../components/banner'
import productContent from '../components/productContent'
import brand from '../components/brand'
import footerA from '../components/footer'
import backTop from '../components/backTop'
import dialogBusiness from '../components/dialogBusiness'
import i1 from '../assets/images/amusement/1.png'
import i2 from '../assets/images/amusement/2.png'
import i3 from '../assets/images/amusement/3.png'
import i4 from '../assets/images/amusement/4.png'
import i5 from '../assets/images/amusement/5.png'
import i6 from '../assets/images/amusement/6.png'
export default {
  data () {
    return {
      problemArr: [
        {label: '数据不通', content: '目前绝大多数门店使用的均是本地系统无法做到多门店数据同步共享需人工进行数据汇总'},
        {label: '会员身份识别困难', content: '一个会员多张会员卡，多占冒领成为普遍现象，生客、熟难以区分同品牌下各门店间会员身份无法通用'},
        {label: '集团管控难度大', content: '行业现集团管控多通过人工行为行政命令进行，系统给到的支撑力度极小，导致管理漏洞频出，标准推进缓慢业务扩张受制于人员经验'},
        {label: '系统迭代困难', content: '随着消费升级的浪潮，从门店自身经营和消费者需求考虑业务场景越来越多样但传统系统升级迭代难且无法做到统一，从而制约企业发展'}
      ],
      product: [
        {img: i1, content: '所有数据全部实施同步至云端汇总，门店无需再自建服务器集团可根据门店、区域、品牌、员工、会员、机台查看数据及分析', label: '数据拉通', type: 'left', style: 'width: 1.6rem; padding-left: 0.5rem;'},
        {img: i2, content: '解决传统场地管理系统各门店间会员不通、会员身份识别以及会员标签化等问题，为门店会员资产运营及精准营销提供数据支持', label: '大会员体系', type: 'right', style: 'width: 1.6rem;padding-right: 0.5rem;'},
        {img: i3, content: '利用SaaS云平台的技术优势，将散落在各门店角落的业务数据全部汇总至集团并配置工作流引擎和明确到人的权限管控，从而使集团实现人员管控、集中采购、供应商维护、各门店经营水平评估，为运营提效降本、经营决策、快速扩张提供系统支持', label: '规范业务行为', type: 'left', style: 'width: 1.6rem; padding-left: 0.5rem;'},
        {img: i4, content: 'SaaS云平台统一运维，快速部署，持续升级迭代，快速响应客户需求', label: '无限迭代升级', type: 'right', style: 'width: 1.6rem;padding-right: 0.5rem;'},
        {img: i5, content: '', label: '快速付款，操作简单，支付安全，全平台支持', type: 'left', style: 'width: 1.6rem; padding-left: 0.5rem;'}
      ],
      bannerObj: {
        img: i6,
        title: '游乐场服务解决方案',
        contentStyle: 'font-size: 0.0625rem;line-height: 0.11rem;width:3.4375rem;',
        content: '针对游乐行业连锁经营趋势，而现阶段行业管理系统多为单店系统，无法满足连锁经营所要求的多门店数据同步、集团管控、升级迭代等需求前海智绘基于旗下场地管理SaaS云平台深入游乐行业，为客户提供一站式“线下游乐+互联网”的数字化运营解决方案，通过对门店进行智能化改造，在满足日常收银与管理的基础上，实现客流统计、设备远程监控、人员管控、集中采购、供应商维护、各门店经营水平评估、数据可视化等功能，为运营提效降本、经营决策、快速扩张提供系统支持。',
        button: '业务咨询'
      },
      title: '解决方案',
      topIndex: 2,
      childrenIndex: 0,
      dialogVisible: false
    }
  },
  components: {
    navTop,
    banner,
    productContent,
    brand,
    backTop,
    footerA,
    dialogBusiness
  },
  methods: {
    getChild (v) {
      this.dialogVisible = v
    },
    closeFn (v) {
      this.dialogVisible = v
    }
  }
}
</script>

<style scoped>
.problem{
  display: flex;
  justify-content: left;
  align-items: center;
  padding: 0 360px;
  box-sizing: border-box;
  margin-bottom: 100px;
}
.problem-title{
  font-size:34px;
  font-family:PingFang SC;
  font-weight:bold;
  line-height:60px;
  color:rgba(51,51,51,1);
  padding: 110px 0;
}
.problem>li{
  width:310px;
  height:310px;
  background:rgba(229,238,255,0.1);
  border:1px solid rgba(229,238,255,1);
  padding: 0 24px;
  margin-right: 18px;
  box-sizing: border-box;
}
.problem>li:last-child{
  margin: 0;
}
.proble-box{
  height: 124px;
  padding-top: 30px;
  box-sizing: border-box;
}
.proble-title{
  font-size:20px;
  font-family:PingFang SC;
  font-weight:bold;
  line-height:28px;
  color:rgba(51,51,51,1);
}
.proble-line{
  width:44px;
  height:5px;
  background:rgba(252,189,1,1);
  margin: 18px auto 0;
}
.proble-content{
  font-size:16px;
  font-family:PingFang SC;
  font-weight:400;
  line-height:28px;
  color:rgba(129,128,128,1);
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/view/amusement.vue